import StyledCard from "components/UI/StyledCard";
import { GridColDef } from "@mui/x-data-grid-premium";
import { useMemo } from "react";
import { OPERATORS } from "../LandingPages/data/constants";
import { CopyValueCell } from "./common/CopyValueCell";
import { getClientExclusionRows } from "./data/helper";
import TreeDataGrid from "./common/TreeDataGrid";
import { useOrbit } from "providers/OrbitProvider";
import Tooltip from "@mui/material/Tooltip";
import { isPresent } from "lib/utils";


const clientExclusionRuleColumns: GridColDef[] = [
  {
    field: 'fieldName',
    groupable: true,
    headerName: 'Field',
    flex: 2,
    cellClassName: 'code-text bold',
  },
  {
    field: 'operator',
    groupable: false,
    headerName: 'Operator',
    cellClassName: 'bold',
    renderCell: ({ value }) =>
      OPERATORS.find((operator) => operator.id === value)?.value ?? value,
    valueFormatter: (value) =>
      OPERATORS.find((operator) => operator.id === value)?.value ?? (value ?? ''),
    flex: 3,
  },
  {
    field: 'value',
    groupable: false,
    headerName: 'Value',
    flex: 2,
    cellClassName: 'code-text bold',
    renderCell: CopyValueCell,
    valueFormatter: (value) => (value ?? ''),
  },
  {
    field: 'text',
    groupable: false,
    headerName: 'Value Detail',
    flex: 2,
  },
  {
    field: 'time',
    groupable: false,
    headerName: 'Time',
    renderCell: ({ value }) => (isPresent(value) ? <Tooltip title={value}>{value}</Tooltip> : value),
    valueFormatter: (value) => (value ?? ''),
    flex: 3,
  },
  {
    field: '__tree_data_group__', // The grouping column (used to order it last)
    width: 100
  }
]

export function ClientLevelExclusionRules({clientExclusionRules, clientTimezone}) {
  const { store, getRemoteId } = useOrbit()

  const rows = useMemo(() => getClientExclusionRows({
    store,
    exclusionRules: clientExclusionRules,
    getRemoteId,
    clientTimezone,
  }), [clientExclusionRules, getRemoteId, store, clientTimezone])

  return (
    <StyledCard
      title='Client-Level Exclusion Rules'
      isSubsection={true}
    >
      <TreeDataGrid
        rows={rows}
        columns={clientExclusionRuleColumns}
        exportRegistration={{ id: 'client-exclusions', sheetName: 'Client Exclusions', order: 2 }}
      />
    </StyledCard>
  )
}
